/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoanGurantors { 
    guarantorType?: string | null;
    userId?: number | null;
    amount?: number;
    guaranteeRatio?: number | null;
    blockedFund?: number;
    isPercentage?: boolean | null;
    nameMember?: string | null;
    memberRelationship?: number | null;
    memberRelationshipText?: string | null;
    dateOfBirth?: string | null;
    phoneNumber?: string | null;
    countryCode?: string | null;
    address?: string | null;
    memberId?: string | null;
    accountNo?: string | null;
    accountName?: string | null;
    accountType?: string | null;
    blockFund?: boolean | null;
}

